import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { ACTION_SUBJECT, EVENT_TYPE, fireAnalyticsEvent } from '@atlaskit/editor-common/analytics';
import { EditorExperience } from '@atlaskit/editor-common/ufo';
/**
 *
 * Util function to be used with the Editor component to send duration analytics
 *
 * @param action
 * @param props
 * @param getExperienceStore return the ExperienceStore of the Editor
 * @param getCreateAnalyticsEvent return the CreateUIAnalyticsEvent of the Editor
 * @returns
 */
export default function sendDurationAnalytics(action, props, getExperienceStore, createAnalyticsEvent) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(duration, startTime) {
      var _props$featureFlags;
      var contextIdentifier, objectId, experienceStore;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return props.contextIdentifierProvider;
          case 2:
            contextIdentifier = _context.sent;
            objectId = contextIdentifier === null || contextIdentifier === void 0 ? void 0 : contextIdentifier.objectId;
            if (createAnalyticsEvent) {
              fireAnalyticsEvent(createAnalyticsEvent)({
                payload: {
                  action: action,
                  actionSubject: ACTION_SUBJECT.EDITOR,
                  attributes: {
                    duration: duration,
                    startTime: startTime,
                    objectId: objectId
                  },
                  eventType: EVENT_TYPE.OPERATIONAL
                }
              });
            }
            if ((_props$featureFlags = props.featureFlags) !== null && _props$featureFlags !== void 0 && _props$featureFlags.ufo) {
              experienceStore = getExperienceStore();
              experienceStore === null || experienceStore === void 0 || experienceStore.mark(EditorExperience.loadEditor, action, startTime + duration);
              experienceStore === null || experienceStore === void 0 || experienceStore.addMetadata(EditorExperience.loadEditor, {
                objectId: objectId
              });
            }
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
}